import { render, staticRenderFns } from "./EditBusinessStepper.vue?vue&type=template&id=24567013&"
import script from "./EditBusinessStepper.vue?vue&type=script&lang=js&"
export * from "./EditBusinessStepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports